import { useExistingNarrative } from '@/hooks/narrative/useExistingNarrative';
import {
  DeferRender,
  MiniPriceChartDefinitions,
  NarrativeMiniPriceChart,
} from '@components/MiniPriceChart';
import type { HoverParam } from '@components/MiniPriceChart';
import useUser from '@/hooks/useUser';
import { CURRENT_PERIOD } from '../../constants';
import { Bones } from '@simplywallst/ui-core';

const CHART_HEIGHT = 70; // Value to match height of first column on small desktop

type Props = {
  companyId: string;
  onHover?: (param: HoverParam) => void;
};

export const NarrativeKeyMetricChart = ({ companyId, onHover }: Props) => {
  const { data: user } = useUser();
  const { data: existingNarrative, status } = useExistingNarrative({
    companyId,
    loggedIn: user.loggedIn,
  });

  if (status === 'pending') {
    return (
      <div className="mt-2">
        <Bones minHeight={CHART_HEIGHT} />
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="mt-2">
        <div
          className="grid place-items-center"
          style={{
            height: CHART_HEIGHT,
          }}
        >
          <p className="text-xs text-bad">An error occurred</p>
        </div>
      </div>
    );
  }

  const { myValuation } = existingNarrative.Company ?? {};

  return (
    <div className="mt-2">
      <MiniPriceChartDefinitions />
      <DeferRender fallback={<Bones minHeight={CHART_HEIGHT} />}>
        <NarrativeMiniPriceChart
          companyId={companyId}
          period={CURRENT_PERIOD}
          align="left"
          fairValue={myValuation?.fairValue ?? null}
          onHover={onHover}
          height={CHART_HEIGHT}
        />
      </DeferRender>
    </div>
  );
};
